import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
// import store from "./store";
import {store} from './store' //

// const cfg = JSON.parse(fs.readFileSync('./config.json'));

require('@/assets/styles/sb-admin-2.min.css')

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
